import { useListContext, useRecordContext } from "react-admin";

// Sequential 1-based row number for a Datagrid, mirroring the item counter shown in the Edit forms.
// Use instead of the backend `order` field so the numbering always follows the displayed row order.
const RowNumberField = () => {
  const record = useRecordContext();
  const { data } = useListContext();
  const index = data?.indexOf(record) ?? -1;

  return <span>{index + 1}</span>;
};

export default RowNumberField;
